import type { QueryKey } from "@tanstack/react-query";

// TODO: Improve typing
type Message = { queryKey: QueryKey; data: unknown };

/**
 * Create a new broadcast channel if the browser supports it.
 */
function createChannel() {
  try {
    if (typeof BroadcastChannel === "undefined") {
      return null;
    }

    return new BroadcastChannel("query-cache");
  } catch (_error) {
    return null;
  }
}

/**
 * Channel for communicating query changes between service worker and the main thread.
 */
export class QueryBroadcastChannel {
  private static readonly channel = createChannel();

  static broadcast(message: Message) {
    QueryBroadcastChannel.channel?.postMessage(message);
  }

  static listen(callback: (message: Message) => void) {
    const listener = (event: MessageEvent) => {
      callback(event.data);
    };

    QueryBroadcastChannel.channel?.addEventListener("message", listener);
    return () => {
      QueryBroadcastChannel.channel?.removeEventListener("message", listener);
    };
  }
}
